import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: "'Roboto', sans-serif",
      color: '#fff',
      background: '#18181b',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <h1 style={{
        fontFamily: "'Bebas Neue', sans-serif",
        fontSize: '8rem',
        color: '#f97316',
        lineHeight: 1,
        marginBottom: '0.5rem'
      }}>404</h1>
      <p style={{
        fontSize: '1.25rem',
        color: '#a1a1aa',
        marginBottom: '2rem'
      }}>{t('notFound.message', 'Page not found')}</p>
      <Link
        to="/"
        style={{
          padding: '0.75rem 2rem',
          background: '#f97316',
          color: '#18181b',
          borderRadius: '4px',
          fontFamily: "'Oswald', sans-serif",
          fontWeight: 600,
          fontSize: '1rem',
          textTransform: 'uppercase',
          textDecoration: 'none'
        }}
      >
        {t('notFound.goHome', 'Go Home')}
      </Link>
    </div>
  );
}
